// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Loads/GeneralLoading/DesignLoading/FireDuration/styles.scss
// module id = 1323
// module chunks = 0